import { NgModule } from "@angular/core";
import { ValueFormatDecimalsPipe } from './value-format-decimals';

@NgModule({
    declarations: [ValueFormatDecimalsPipe],
    exports: [ValueFormatDecimalsPipe]
})
export class ValueFormatDecimalsPipeModule {}